import { MkIcon } from "@/mk/MkIcon";
export interface ChoiceOption<T extends string | number | boolean = string> {
    id: T;
    label: string;
    icon?: string;
}

interface Props<T extends string | number | boolean> {
    options: ChoiceOption<T>[];
    value?: T;
    label?: string;
    wrap?: boolean;
    compact?: boolean;
    className?: string;
    onChange?(value: T, option: ChoiceOption<T>): void;
}

export function MkChoice<T extends string | number | boolean>({
    options, value, label, wrap, compact, className, onChange,
}: Props<T>) {
    const classes = ["mk-choice", wrap ? "mk-choice-wrap" : "", compact ? "mk-choice-compact" : "",
                     className ?? ""].filter(Boolean).join(" ");
    return (
        <div className="mk-choice-field">
            {label && <label className="mk-field-label">{label}</label>}
            <div className={classes} role="radiogroup">
                {options.map((option) => {
                    const selected = option.id === value;
                    return (
                        <button key={String(option.id)} type="button"
                                className={`mk-choice-opt${selected ? " mk-choice-opt-active" : ""}`}
                                role="radio" aria-checked={selected ? "true" : "false"}
                                title={option.label}
                                onClick={() => {
                                    if (!selected) {
                                        onChange?.(option.id, option);
                                    }
                                }}>
                            {option.icon && <MkIcon name={option.icon} />}
                            {!compact && <span className="mk-choice-opt-label">{option.label}</span>}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
